import { ReactComponent as SvgChevronLeft } from '@img/icons/chevron-left.svg';
import { ReactComponent as SvgSearch } from '@img/icons/search.svg';
import { locations } from '@redux/slices/locations';
import { useAppDispatch } from '@redux/store';
import * as React from 'react';
import S from './FilterSimple.styles';
const FilterSimple = (props) => {
    const [locationRaw, setLocationRaw] = React.useState(props.params.location);
    const dispatch = useAppDispatch();
    const selectedTypes = getSelectedTypes();
    const selectedRangesOthers = getSelectedRangesOthers();
    const selectedRangesSlidingWardrobes = getSelectedRangesSlidingWardrobes();
    return (React.createElement(S.Container, null,
        React.createElement(S.Form, { onSubmit: (event) => {
                event.preventDefault();
                props.onChange({ location: locationRaw });
            } },
            React.createElement(S.Input, { id: "location", name: "location", placeholder: "Enter postcode", type: "search", value: locationRaw, onChange: handleLocationChange }),
            React.createElement(S.SubmitButton, { type: "submit", "aria-label": "Search" },
                React.createElement(SvgSearch, null))),
        selectedTypes.length > 0 && (React.createElement(S.FilterWrapper, null,
            React.createElement(S.FilterTitle, null, "Showing showrooms with"),
            React.createElement(S.FilterList, null, selectedTypes.map((option) => (React.createElement(S.FilterItem, { key: option.id },
                React.createElement("input", { id: `type-${option.id}`, checked: props.params.types.includes(option.id), name: "type", type: "checkbox", value: option.id, onChange: handleFilterChange }),
                React.createElement("label", { htmlFor: `type-${option.id}` }, option.text))))),
            selectedRangesOthers.length > 0 && (React.createElement(S.FilterWrapper, null,
                React.createElement(S.Divider, null),
                React.createElement(S.FilterList, null, selectedRangesOthers.map((option) => (React.createElement(S.FilterItem, { key: option.id },
                    React.createElement("input", { id: `type-${option.id}`, checked: props.params.rangesOthers.includes(option.id), name: "type", type: "checkbox", value: option.id, onChange: handleRangesOthersFilterChange }),
                    React.createElement("label", { htmlFor: `type-${option.id}` }, option.text))))))),
            selectedRangesSlidingWardrobes.length > 0 && (React.createElement(S.FilterWrapper, null,
                React.createElement(S.Divider, null),
                React.createElement(S.FilterList, null, selectedRangesSlidingWardrobes.map((option) => (React.createElement(S.FilterItem, { key: option.id },
                    React.createElement("input", { id: `type-${option.id}`, checked: props.params.rangesSliding.includes(option.id), name: "type", type: "checkbox", value: option.id, onChange: handleRangesSlidingWardrobesFilterChange }),
                    React.createElement("label", { htmlFor: `type-${option.id}` }, option.text))))))))),
        React.createElement(S.BackWrapper, null,
            React.createElement(S.BackButton, { type: "button", onClick: (event) => {
                    event.preventDefault();
                    dispatch(locations.actions.toggleFilter(true));
                } },
                React.createElement(S.BackIcon, { as: SvgChevronLeft }),
                "Return to Search"))));
    function getSelectedTypes() {
        return props.types.filter((item) => props.params.types.includes(item.id)).slice(0, 3);
    }
    function getSelectedRangesOthers() {
        return props.rangesOthers.filter((item) => props.params.rangesOthers.includes(item.id));
    }
    function getSelectedRangesSlidingWardrobes() {
        return props.rangesSlidingWardrobes.filter((item) => props.params.rangesSliding.includes(item.id));
    }
    function handleLocationChange(event) {
        setLocationRaw(event.target.value);
    }
    function handleFilterChange(event) {
        const value = event.target.value;
        const typesSet = new Set(props.params.types);
        if (typesSet.has(value)) {
            typesSet.delete(value);
        }
        else {
            typesSet.add(value);
        }
        // Convert set to array.
        const newTypes = [...typesSet];
        const paramChanges = {
            types: newTypes,
        };
        // Clear sliding wardrobes ranges if not selected anymore.
        if (newTypes.every((item) => item !== props.slidingWardrobesId)) {
            paramChanges.rangesSliding = [];
        }
        // Clear non-sliding wardrobes ranges if not selected anymore.
        if (newTypes.every((item) => item === props.slidingWardrobesId)) {
            paramChanges.rangesOthers = [];
        }
        props.onChange(paramChanges);
    }
    function handleRangesOthersFilterChange(event) {
        const value = event.target.value;
        const typesSet = new Set(props.params.rangesOthers);
        if (typesSet.has(value)) {
            typesSet.delete(value);
        }
        else {
            typesSet.add(value);
        }
        // Convert set to array.
        const newTypes = [...typesSet];
        const paramChanges = {
            rangesOthers: newTypes,
        };
        props.onChange(paramChanges);
    }
    function handleRangesSlidingWardrobesFilterChange(event) {
        const value = event.target.value;
        const typesSet = new Set(props.params.rangesSliding);
        if (typesSet.has(value)) {
            typesSet.delete(value);
        }
        else {
            typesSet.add(value);
        }
        // Convert set to array.
        const newTypes = [...typesSet];
        const paramChanges = {
            rangesSliding: newTypes,
        };
        props.onChange(paramChanges);
    }
};
export default FilterSimple;
